import { supabase } from '@/integrations/supabase/client';

export interface TaskCompletionWebhookData {
  taskName: string;
  userName: string;
  scheduledDay: string | null;
  scheduledTime: string | null;
  completedAt: string;
  taskCoins: number;
  totalUserCoins: number;
}

export async function sendTaskCompletionWebhook(data: TaskCompletionWebhookData): Promise<void> {
  try {
    console.log('Sending task completion webhook:', data);
    
    const { error } = await supabase.functions.invoke('send-task-completion-webhook', {
      body: data,
    });

    if (error) {
      console.error('Error sending task completion webhook:', error);
    } else {
      console.log('Task completion webhook sent successfully');
    }
  } catch (error) {
    console.error('Error sending task completion webhook:', error);
    // Don't throw - we don't want to break task completion if webhook fails
  }
}

// Test function to verify webhook connectivity
export async function testWebhook(): Promise<void> {
  try {
    console.log('Testing webhook...');
    const { error } = await supabase.functions.invoke('send-task-completion-webhook', {
      body: { test: true },
    });
    if (error) {
      console.error('Test webhook error:', error);
    } else {
      console.log('Test webhook sent!');
    }
  } catch (error) {
    console.error('Test webhook error:', error);
  }
}
